<template>
	<div class="chat-fans-container">
		<div class="chat-fans-box">
			<div class="chat-fans-coustom" :style="{'display': customDisplay}">
				<chat-custom @custom-call="customCall($event)" @chat-custom-call="chatCustomCall($event)"></chat-custom>
			</div>
			<div class="chat-fans-list-box">
				<chat-fans-list 
					:currentCustom = "currentCustom"
					:customList = "customList"
					:deleteFanspassId = "deleteFanspassId"
					@custom-filter="customFilterCall($event)" 
					@fans-click="fansClickCall($event)">
				</chat-fans-list>
			</div>
		</div>
		<div class="chat-fans-info">
			<chat-fans-info v-if="currentFans.id !== undefined" 
				@delete-fanspass-call="deleteFanspassCall($event)"
				:fansInfo="currentFans" 
				:customList="customList">
			</chat-fans-info>
			<chat-empty showText="请选择一个粉丝" v-else></chat-empty>
		</div>
	</div>
</template>

<script>
	import ChatCustom from '../../../components/ChatCustom.vue'
	import ChatFansList from './ChatFansList.vue'
	import ChatFansInfo from './ChatFansInfo.vue'
	import ChatEmpty from '../../../components/ChatEmpty.vue'

	export default {
		name: "ChatFansHome",
		data(){
			return {
				customDisplay: 'none',
				currentFans:{},
				currentCustom:{
					id:0
				},
				customList:[],
				deleteFanspassId: 0
			}
		},
		components:{
			ChatCustom,
			ChatFansList,
			ChatFansInfo,
			ChatEmpty
		},
		methods:{			
			// 客服过滤点击回调
			customFilterCall(val){
				val ? this.customDisplay = 'block' :  this.customDisplay = 'none'
			},
			
			// 客服点击回调
			customCall(data){
				this.currentCustom = data
			},
			
			// 客服类别回调
			chatCustomCall(data){
				this.customList = data
			},
			
			// 粉丝列表点击回调
			fansClickCall(val){
				this.currentFans = val
			},
			
			// 删除进粉回调
			deleteFanspassCall(id){
				this.deleteFanspassId = id
			}
			
		}
	}
</script>

<style>
	.chat-fans-container{
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		overflow: hidden;
	}
	.chat-fans-container .chat-fans-box{
		width: 400px;
		height: 100%;
		overflow: hidden;
		display: flex;
		justify-content: flex-start;
		align-items: flex-start;
		flex-wrap: nowrap;
		background-color: #efefef;
	}
	.chat-fans-box .chat-fans-coustom{
		width: 80px;
		height: 100%;
		overflow: hidden;
	}
	.chat-fans-box .chat-fans-list-box{
		width: 0;
		flex-grow: 1;
		height: 100%;
		overflow: hidden;
	}
	.chat-fans-container .chat-fans-info{
		position: absolute;
		top: 0;
		left: 400px;
		bottom: 0;
		right: 0;
		overflow: hidden;
	}
</style>
